import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-patient-validation-messages',
    templateUrl: './patient-validation-messages.component.html'
})
export class PatientValidationMessagesComponent {

    @Input() valStatus: any = { showIncompleteFile: false, showICDValidation: false, showSelfBoarded: false, showInviteStatus: false };
    /** Icons only (their tooltips explain them), for one-line rows such as the compact day list. */
    @Input() iconsOnly = false;

    get hasErrors() {
        return this.valStatus.showIncompleteFile || this.valStatus.showICDValidation || this.valStatus.showSelfBoarded || this.valStatus.showInviteStatus;
    }
} 